import { render, staticRenderFns } from "./SocialMediaLinks.vue?vue&type=template&id=06dceea5&scoped=true&"
import script from "./SocialMediaLinks.vue?vue&type=script&lang=js&"
export * from "./SocialMediaLinks.vue?vue&type=script&lang=js&"
import style0 from "./SocialMediaLinks.vue?vue&type=style&index=0&id=06dceea5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06dceea5",
  null
  
)

export default component.exports